import { render, staticRenderFns } from "./RoyaltiesCalculator.vue?vue&type=template&id=1e3cd107&scoped=true&"
import script from "./RoyaltiesCalculator.vue?vue&type=script&lang=js&"
export * from "./RoyaltiesCalculator.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltiesCalculator.vue?vue&type=style&index=0&id=1e3cd107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cd107",
  null
  
)

export default component.exports